import _extends from "@babel/runtime/helpers/extends";
import '../../css-tokens';
import React from 'react';
import styles from './index.module.css';
const ChoiceBody = props => /*#__PURE__*/React.createElement("div", _extends({}, props, {
  className: styles.body
}));
export default ChoiceBody;